import axios from 'axios';
import Url from '../constants/Url';

class PayoutApi {
    getPayoutReport(params) {
        return axios
            .get(Url().GET_PAYOUT_REPORT, {params})
            .then(response => response.data)
            .catch(ex => {
                console.error('Failed to getPayoutReport:', ex.message);
                throw ex;
            });
    }

    getPayoutReportList(params) {
        return axios
            .get(Url().GET_PAYOUT_REPORT_LIST, {params})
            .then(resp => resp.data)
            .catch(ex => {
                console.error('Failed to getPayoutReportList', ex.message);
                throw ex;
            });
    }

    getPayoutReportDetail(params) {
        return axios
            .get(Url().GET_PAYOUT_REPORT_DETAIL, {params})
            .then(resp => resp.data)
            .catch(ex => {
                console.error('Failed to get payout report detail', ex.message);
                throw ex;
            });
    }

    getPayoutAcceptance() {
        return axios
            .get(Url().GET_PAYOUT_ACCEPTANCE)
            .then(resp => resp.data)
            .catch(ex => {
                console.error('Failed to get payout accept instance', ex.message);
                throw ex;
            });
    }

    getPayableAmounts() {
        return axios
            .get(Url().GET_PAYABLE_AMOUNTS)
            .then(resp => resp.data)
            .catch(ex => {
                console.error('Failed to get PAYABLE AMOUNTS', ex.message);
                throw ex;
            });
    }

    getOfflinePayment() {
        return axios
            .get(Url().GET_OFFLINE_PAYMENT)
            .then(resp => resp.data)
            .catch(ex => {
                console.error('Failed to get offline payment', ex.message);
                throw ex;
            });
    }

    saveOfflinePayment(data) {
        return axios
            .post(Url().SAVE_OFFLINE_PAYMENT, data)
            .then(resp => resp.data)
            .catch(ex => {
                console.error('Failed to update offline payment', ex.mssage);
                throw ex;
            });
    }

    traceSecurityLink() {
        return axios.post(Url().TRACE_SECURITY_LINK, {});
    }
}

export default new PayoutApi();
